/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import React, { Fragment } from 'react';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import { isPc } from './utils';

type TooltipProps = Tooltip['props']

interface ITooltipPackageProps {
    children: React.ReactNode;
    options: TooltipProps;
}

const defaultTooltipOptions: TooltipProps = {
    trigger: 'hover',
    alignment: 'end',
};

const TooltipPackage = (props: ITooltipPackageProps) => {
    const { children, options } = props;
    return isPc()
        ? <Tooltip {...defaultTooltipOptions} {...options}>
            {children}
        </Tooltip>
        : <Fragment>
            {children}
        </Fragment>
        
};
export default TooltipPackage;
